import { error } from 'react-notification-system-redux'
import i18n from './i18n'

const notificationOpts = (message) => ({
  message,
  position: 'tr',
  autoDismiss: 5
})

export default (wholeError) => {
  const { code } = wholeError

  const errorMessage = i18n.t([`errors:${code}`, 'errors:unknown'])

  return error(notificationOpts(errorMessage))
}
